export default __webpack_public_path__ + "static/media/icon-too-happy-face-full.f13905a7.svg";